var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "print",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "icon line",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M17,17h3a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H4A1,1,0,0,0,3,8v8a1,1,0,0,0,1,1H7",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M17,7H7V4A1,1,0,0,1,8,3h8a1,1,0,0,1,1,1Zm0,13V12H7v8a1,1,0,0,0,1,1h8A1,1,0,0,0,17,20Z",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.51d6114dbb70647ddf99b95a7357608d.svg";
export { ForwardRef as ReactComponent };